module.exports = __webpack_public_path__ + "img/builder-19.7d235ddb.jpg";